/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type UtxFeeCalcFeeForUserPolicyName = typeof UtxFeeCalcFeeForUserPolicyName[keyof typeof UtxFeeCalcFeeForUserPolicyName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UtxFeeCalcFeeForUserPolicyName = {
  fiat_deposit: 'fiat_deposit',
  fiat_withdrawal: 'fiat_withdrawal',
  deposit: 'deposit',
  withdrawal: 'withdrawal',
  exchange: 'exchange',
  general_instruction: 'general_instruction',
  bill_payment: 'bill_payment',
  transfer_p2p: 'transfer_p2p',
} as const;
